export const TEST_ID = 'prescriptionSection';

export const ERROR_BANNER_TEST_ID = 'prescriptionSectionErrorBanner';
